module.exports = __webpack_public_path__ + "img/bg-gopal-sharma.e4b6d240.jpg";